// extracted by mini-css-extract-plugin
export default {"cta":"jG-z","disabled":"kG-z"};